export enum NotificationKind {
  LessonCancelled = "lesson_cancelled",
  HomeworkUpdated = "homework_updated",
  StudentResigned = "student_resigned",
  LessonPaid = "lesson_paid",
  NewTimeSlotApplication = "new_time_slot_application",
  Custom = "custom",
}
